
import { SET_IS_FORM_OPEN, SET_UPDATE_SECTION} from "../actions/types";

const initialState = {
  isFormOpen: {
    PARENTS_AND_CHILDREN: false,
    WAGES_AND_SALARIES: false,
    TIME_WITH_PARENTS: false,
    TAX_ESTIMATOR: false,
  },
  updateSection: ''
}

const uiReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_IS_FORM_OPEN:
      let newIsOpen = state.isFormOpen;
      newIsOpen[payload.type] = payload.value
      return {
        ...state,
        isFormOpen: newIsOpen,
      }
    case SET_UPDATE_SECTION:
      return{
        ...state,
        updateSection: payload
      }
    default:
      return state;
  }
}


export default uiReducer;